import { render, staticRenderFns } from "./odometer_data.vue?vue&type=template&id=212800f9"
import script from "./odometer_data.vue?vue&type=script&lang=js"
export * from "./odometer_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports